module.exports = __webpack_public_path__ + "assets/img/2017_2.4ff03cf5.png";